import React from "react";

const RouletteResult = ({ resultData }) => {

    // Convert all result objects into one history array
    const resultHistory = (resultData || [])
        .map(item => Number(item.result))
        .filter(item => item > 0);

    const rows = [];
    for (let i = 0; i < resultHistory.length; i += 10) {
        rows.push(resultHistory.slice(i, i + 10));
    }

    return (
        <div className="left-content">

            <div
                className="card"
                style={{
                    border: "1px solid rgb(204, 204, 204)",
                    borderRadius: "8px",
                    padding: "15px",
                    background: "linear-gradient(rgb(15,15,15), rgb(251,251,251))"
                }}
            >

                <div className="cardAV">

                    <div className="card-headerAV">
                        Results for Last 50 Rounds
                    </div>

                    <div className="card-bodyAV">

                        {rows.map((row, rowIndex) => (
                            <div className="rowAV" key={rowIndex}>
                                {row.map((item, colIndex) => (

                                    <div className="colAV" key={colIndex}>
                                        <div className="result-itemAV border-normal">
                                            {item}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        ))}

                    </div>

                </div>

            </div>

        </div>
    );
};

export default RouletteResult;